// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"5175484b","1192":"252995db","1466":"65f07e72","3125":"6689d445","6397":"252995db","7171":"5175484b","7714":"78262bde","9153":"65f07e72"}[chunkId] + ".chunk.css";
};